import axios from 'axios';

const actions = {
  
 
};
const mutations = {};
const state = {};
export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
